/* eslint-disable */
/* Code generated by ng-openapi-gen DO NOT EDIT. */

import { HttpClient, HttpContext } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { Observable } from 'rxjs';
import { map } from 'rxjs/operators';

import { TranslationsBaseService } from '../translations-base-service';
import { TranslationsApiConfiguration } from '../translations-api-configuration';
import { TranslationsStrictHttpResponse } from '../translations-strict-http-response';

import { customTemplatesControllerTranslateCustomTemplate } from '../fn/custom-templates/custom-templates-controller-translate-custom-template';
import { CustomTemplatesControllerTranslateCustomTemplate$Params } from '../fn/custom-templates/custom-templates-controller-translate-custom-template';
import { TranslationsTranslateCustomTemplateResponseDto } from '../models/translations-translate-custom-template-response-dto';

@Injectable({ providedIn: 'root' })
export class TranslationsCustomTemplatesService extends TranslationsBaseService {
  constructor(config: TranslationsApiConfiguration, http: HttpClient) {
    super(config, http);
  }

  /** Path part for operation `customTemplatesControllerTranslateCustomTemplate()` */
  static readonly CustomTemplatesControllerTranslateCustomTemplatePath = '/o2-translations/custom-templates/translate/{name}';

  /**
   * Translate a custom template to English.
   *
   * Downloads the source (Italian) custom template from S3, translates it to English via AWS Translate (embedded images are preserved) and uploads the result next to the source with an `_en` key suffix. Re-translating the same source overwrites the same English key. The client must validate the placeholder integrity of the translated template before persisting the key on the tenant.
   *
   * This method provides access to the full `HttpResponse`, allowing access to response headers.
   * To access only the response body, use `customTemplatesControllerTranslateCustomTemplate()` instead.
   *
   * This method sends `application/json` and handles request body of type `application/json`.
   */
  customTemplatesControllerTranslateCustomTemplate$Response(params: CustomTemplatesControllerTranslateCustomTemplate$Params, context?: HttpContext): Observable<TranslationsStrictHttpResponse<TranslationsTranslateCustomTemplateResponseDto>> {
    const obs = customTemplatesControllerTranslateCustomTemplate(this.http, this.rootUrl, params, context);
    return obs;
  }

  /**
   * Translate a custom template to English.
   *
   * Downloads the source (Italian) custom template from S3, translates it to English via AWS Translate (embedded images are preserved) and uploads the result next to the source with an `_en` key suffix. Re-translating the same source overwrites the same English key. The client must validate the placeholder integrity of the translated template before persisting the key on the tenant.
   *
   * This method provides access only to the response body.
   * To access the full response (for headers, for example), `customTemplatesControllerTranslateCustomTemplate$Response()` instead.
   *
   * This method sends `application/json` and handles request body of type `application/json`.
   */
  customTemplatesControllerTranslateCustomTemplate(params: CustomTemplatesControllerTranslateCustomTemplate$Params, context?: HttpContext): Observable<TranslationsTranslateCustomTemplateResponseDto> {
    const resp = this.customTemplatesControllerTranslateCustomTemplate$Response(params, context);
    return resp.pipe(
      map((r: TranslationsStrictHttpResponse<TranslationsTranslateCustomTemplateResponseDto>): TranslationsTranslateCustomTemplateResponseDto => r.body)
    );
  }

}
